import firebase from 'firebase/app';
import 'firebase/auth';

export default {
    namespaced: true,
    state: {
        user: {
            loggedIn: false,
            admin: false,
            data: null
        }
    },
    getters: {
        user: state => state.user
    },
    mutations: {
        SET_LOGGED_IN(state, value) {
            state.user.loggedIn = value;
        },
        SET_USER_ROLE(state, value) {
            state.user.admin = value;
        },
        SET_USER(state, data) {
            state.user.data = data;
        }
    },
    actions: {
        fetchUser({commit}, user) {
            commit('SET_LOGGED_IN', !!user);
            if (user) {
                commit('SET_USER', user);
                firebase.auth().currentUser.getIdTokenResult().then(res => {
                    commit('SET_USER_ROLE', !!res.claims.admin);
                });
            } else {
                commit('SET_USER', null);
            }
        }
    }
}
